<template>
	<div
		class="social"
		:class="{'social--closed':!open}"
		>
		<button
			class="social__toggle"
			:class="{'social__toggle--open':open}"
			@click="open = !open">
			<i class="fas fa-chevron-circle-left"></i>
		</button>
		<div class="section social__profile">
			<router-link
				tag="a"
				class="social__profile__link"
				:to="`/profile/${$store.state.authentication.user.username}`">
				<i class="section__header__icon social__profile__link__picture fas fa-user-circle"></i>
				<div class="social__profile__link__info">
					<p class="social__profile__link__info__name">{{user.first_name}} {{user.last_name}}</p>
					<p v-if="user.School" class="social__profile__link__info__school">{{toUpperCase(user.School.name)}}</p>
				</div>
			</router-link>
		</div>
		<div
			class="section">
			<p class="section__header">
				<i class="section__header__icon fas fa-heart"></i>
				FRIENDS ({{friendAmount}})
			</p>
			<router-link
				v-for="friend in friends"
				:key="friend.User.username"
				tag="li"
				class="link"
				:class="{'link--active':isActive('profile', friend.User.username)}"
				:to="`/profile/${friend.User.username}`">
				<i class="link__icon__element link__icon--offset fas fa-user-circle"></i>
				<a>{{friend.User.username}}</a>
			</router-link>
		</div>
		<div class="section" v-if="showFriendRequests">
			<p class="section__header">
				<i class="section__header__icon fas fa-user-plus"></i>
				FRIEND REQUESTS
			</p>
			<div
				v-for="friendRequest in friendRequests"
				:key="friendRequest.Sender.username"
				class="social__friend-request">
				<router-link
					tag="li"
					class="link social__friend-request__info"
					:to="`/profile/${friendRequest.Sender.username}`">
					<i class="link__icon__element link__icon--offset fas fa-user-circle"></i>
					<a class="social__friend-request__name">
						{{friendRequest.Sender.username}}
					</a>
				</router-link>
				<p class="social__friend-request__time">{{formatPast(friendRequest.createdAt)}}</p>
				<div class="social__friend-request__buttons">
					<button	class="social__friend-request__accept"
						@click="handleFriendRequest(true, friendRequest.Sender.username)">
						<i class="far fa-check-circle"></i>
						Accept
					</button>
					<button	class="social__friend-request__decline"
						@click="handleFriendRequest(false, friendRequest.Sender.username)">
						<i class="far fa-times-circle"></i>
						Decline
					</button>
				</div>
			</div>
		</div>
		<div class="section">
			<p class="section__header">
				<i class="section__header__icon fas fa-envelope"></i>
				UPDATES
			</p>
		</div>
	</div>
</template>

<script>
import DateService from '@/services/DateService'
import ProfileService from '@/services/ProfileService'
export default {
	data () {
		return {
			open: false
		}
	},
	methods: {
		isActive (link, id) {
			var options = []
			switch (link) {
			case 'profile':
				options = [`/profile/${id}`]
				break
			}
			var path = id ? this.$route.path : this.$route.name
			return options.includes(path)
		},
		async handleFriendRequest (accepted, username) {
			if (accepted) await ProfileService.befriend(username)
			else await ProfileService.unfriend(username)
			this.$store.dispatch('getFriends')
		},
		formatPast (date) {
			return DateService.formatPast(date)
		},
		toUpperCase (text) {
			return text.toUpperCase()
		}
	},
	computed: {
		friendAmount () {
			if (!this.friends) return 0
			else return this.friends.length
		},
		friends () {
			return this.$store.state.social.friends
		},
		friendRequests () {
			const username = this.$store.state.authentication.user.username
			var friendRequests = this.$store.state.social.friendRequests
			if (!friendRequests) return null
			return friendRequests.filter(friendRequest => friendRequest.Receiver.username === username)
		},
		showFriendRequests () {
			if (!this.friendRequests) return false
			if (this.friendRequests.length === 0) return false
			return true
		},
		user () {
			return this.$store.state.authentication.user
		}
	},
	created () {
	}
}
</script>

<style scoped lang="scss">
@import "@/styles/components/_sidebar.scss";
@import "@/styles/components/_social.scss";
.section__header {
	&__icon {
		position: absolute;
		top: 50%;
		left: calc(-0.5 * #{$sidebar-width-closed});
		transform: translateX(-50%) translateY(-50%);
	}
}
</style>
